import { Line } from 'vue-chartjs'

export default {
    extends: Line,

    props: {
        chartdata: {
            type: Object,
            default: null,
        },
        options: {
            type: Object,
            default: null,
        },
    },

    mounted() {
        if (this.chartdata && this.$refs.canvas) {
            this.renderChart(this.chartdata, this.options)
        }
    },

    watch: {
        chartdata: {
            handler(newVal) {
                if (!newVal || !this.$refs.canvas) return
                this.$nextTick(() => {
                    if (!this.$refs.canvas) return
                    try {
                        this.renderChart(this.chartdata, this.options)
                    } catch (_) {
                        // Ignore render errors (e.g. during teardown).
                    }
                })
            },
            deep: true,
        },
    },

    beforeDestroy() {
        const chart = this.$data._chart
        if (chart) {
            try {
                chart.destroy()
            } catch (_) {
                // Chart may already be destroyed.
            }
        }
    },
}
